export default "__VITE_ASSET__f5dcf31c__"